module.exports = __webpack_public_path__ + "img/food.110201e9.svg";